import { useEffect, useRef } from "react";
import { buildNotesSummaryText } from "./notesHub";

const DEBOUNCE_MS = 2000;

/**
 * Keeps the lead's "MC Dashboard Notes" entry in the notes table in step with
 * the Notes Hub: when any stage note of the open job changes, the full
 * copy-paste summary is sent (quietly — no toast) once the MC has paused for
 * two seconds; the backend rewrites that one general note. Opening a job sends
 * nothing; a job with no lead behind it is skipped.
 */
export const useNotesHubSync = (job, sync) => {
  const text = job ? buildNotesSummaryText(job, job.moveType === "ld") : "";
  const jobId = job ? job.id : null;
  const leadId = job ? job.leadId : null;
  const last = useRef({ jobId: null, text: "" });

  useEffect(() => {
    if (last.current.jobId !== jobId) {
      last.current = { jobId, text }; // opened: remember the baseline, send nothing
      return undefined;
    }
    if (text === last.current.text || !leadId) return undefined;
    const timer = setTimeout(() => {
      last.current.text = text;
      sync({ leadId, event: "notes-hub", text });
    }, DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [jobId, leadId, text, sync]);
};
